var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuphoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#00A12F",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4511 13.691C19.3172 13.279 18.9332 13 18.5 13C18.0668 13 17.6828 13.279 17.5489 13.691L16.3141 17.4914H12.3181C11.8849 17.4914 11.501 17.7703 11.3671 18.1824C11.2332 18.5944 11.3799 19.0458 11.7303 19.3004L14.9632 21.6492L13.7283 25.4496C13.5945 25.8616 13.7411 26.313 14.0916 26.5676C14.4421 26.8223 14.9167 26.8223 15.2672 26.5676L18.5 24.2188L21.7328 26.5676C22.0833 26.8223 22.5579 26.8223 22.9084 26.5676C23.2589 26.313 23.4055 25.8616 23.2717 25.4496L22.0368 21.6492L25.2697 19.3004C25.6201 19.0458 25.7668 18.5944 25.6329 18.1824C25.4991 17.7703 25.1151 17.4914 24.6819 17.4914H20.6859L19.4511 13.691Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4511 13.691C37.3172 13.279 36.9332 13 36.5 13C36.0668 13 35.6828 13.279 35.5489 13.691L34.3141 17.4914H30.3181C29.8849 17.4914 29.501 17.7703 29.3671 18.1824C29.2332 18.5944 29.3799 19.0458 29.7303 19.3004L32.9632 21.6492L31.7283 25.4496C31.5945 25.8616 31.7411 26.313 32.0916 26.5676C32.4421 26.8223 32.9167 26.8223 33.2672 26.5676L36.5 24.2188L39.7328 26.5676C40.0833 26.8223 40.5579 26.8223 40.9084 26.5676C41.2589 26.313 41.4055 25.8616 41.2717 25.4496L40.0368 21.6492L43.2697 19.3004C43.6201 19.0458 43.7668 18.5944 43.6329 18.1824C43.4991 17.7703 43.1151 17.4914 42.6819 17.4914H38.6859L37.4511 13.691Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5047 33H37.4953C37.4237 34.513 36.5412 35.9605 34.9868 37.0796C33.3655 38.247 31.0753 39 28.5 39C25.9247 39 23.6345 38.247 22.0132 37.0796C20.4588 35.9605 19.5763 34.513 19.5047 33Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuphoria);
export default __webpack_public_path__ + "static/media/Euphoria.d22868a7f935cf347aad2da9f152c855.svg";
export { ForwardRef as ReactComponent };